import React from "react";

export const useShowIntercom = (): (() => void) => {
  return React.useCallback((): void => {
    if (
      typeof window !== "undefined" &&
      typeof window.Intercom !== "undefined"
    ) {
      window.Intercom("show");
    } else {
      console.log(
        "Intercom is not available. This might be due to the window object being inaccessible or Intercom not being present on the window object.",
      );
    }
  }, []);
};
